import { createSlice } from "@reduxjs/toolkit";
import { VEHICLES_INFORMATION } from "@/constants/vehiclesData";

const initialState = {
  hotDealsVehiclesData: [],
  hotDealsVehiclesDataLoading: false,
  vehiclesData: [],
  isLoading: false,
};

const vehicleSlice = createSlice({
  name: "vehicles",
  initialState,
  reducers: {
    setVehiclesInfo(state, action) {
      state.vehiclesData = action.payload?.vehiclesData;
      state.isLoading = action.payload?.isLoading;
    },
    setHotDealVehicleData(state = initialState, action) {
      const { hotDealsVehiclesData, hotDealsVehiclesDataLoading } =
        action.payload;
      return {
        ...state,
        hotDealsVehiclesData: hotDealsVehiclesData,
        hotDealsVehiclesDataLoading: hotDealsVehiclesDataLoading,
      };
    },
  },
});

export const { setVehiclesInfo, setHotDealVehicleData } = vehicleSlice.actions;

export default vehicleSlice.reducer;
